import { useNavigate } from "react-router-dom";

import * as compSettings from "./settings";




export default function Welcome({id,extendedSettings}) {
  const navigate = useNavigate();
  const settings = {
    ...compSettings,
    ...extendedSettings?.[id],
  };

  const onLoginPress = () => {
    navigate("/login");
  };
  const onRegisterPress = () => {
    navigate("/register");
  };
    const logo = JSON.parse(settings.logo.value)[0].original
  return (
    <div>
      <div className="flex flex-col items-center justify-center w-[80%] self-center mx-auto">
        <img src={logo} className="w-[50%] mt-[30vh]" />

        <p
          className="w-full bg-black text-white p-3 mt-4 font-bold rounded-xl text-center"
          onClick={onLoginPress}
        >
          Şifre ile giriş yap
        </p>

        <p
          className="w-full text-lg text-black font-bold p-3 mt-3 rounded-xl text-center"
          onClick={onRegisterPress}
        >
          Hesabınız yok mu? Üye ol
        </p>
      </div>
    </div>
  );
}